<template>
    <div class="specification">
        <div class="control-width mx-auto">
            <div class="p-4 p-md-5 border shadow-sm add-rounded">
                <h4 class="mb-4 font-weight-bold kova-text"> Do you have product specifications ready?</h4>
                <div class="text-left">
                    <label class="checkbox-label mb-3">
                        <input type="checkbox" />
                        <span class="checkbox-custom rectangular"></span><span class="pl-4 ml-2 mb-3 input-title">System/Product requirement specifications (SRS) document</span>
                    </label><br />
                    <label class="checkbox-label mb-3">
                        <input type="checkbox" />
                        <span class="checkbox-custom rectangular"></span><span class="pl-4 ml-2 pb-2 input-title">Wireframes</span>
                    </label><br />
                    <label class="checkbox-label mb-3">
                        <input type="checkbox" />
                        <span class="checkbox-custom rectangular"></span><span class="pl-4 ml-2 pb-2 input-title">UI/UX prototype</span>
                    </label><br />
                    <label class="checkbox-label mb-3">
                        <input type="checkbox" />
                        <span class="checkbox-custom rectangular"></span><span class="pl-4 ml-2 pb-2 input-title">No,only have idea what I want to build</span>
                    </label><br />

                    <a-upload-dragger
                        name="file"
                        :multiple="true"
                        action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                        @change="handleChange"
                    >
                        <p class="ant-upload-drag-icon">
                        <a-icon type="upload" />
                        </p>
                        <p class="ant-upload-text">Click or drag file to this area to upload</p>
                        <p class="ant-upload-hint">
                        <!-- Support for a single or bulk upload. Strictly prohibit from uploading company data or other
                        band files -->
                        </p>
                    </a-upload-dragger>
                </div>
                <div class="container-fluid px-0 px-md-4 mb-5 mt-5">
                    <div class="row">
                        <div class="col text-left">
                            <button class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="goBack"> Back </button>
                        </div>
                        <div class="col text-right">
                            <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="next">Next </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-right kova-text pt-3 mr-4">
                <span @click="skip">Skip <font-awesome-icon icon="step-forward"></font-awesome-icon></span>
            </div>
        </div>
        
        
 </div>
</template>
<script>
export default {
    name: 'specification',
    data(){
        return {
            
        }
    },
    methods: {
        goBack(){
            this.$router.go(-1)
        },
        next(){
            this.$router.push({path:'work-hours'})
        },
        skip(){
            this.$router.push({path:'work-hours'})
        }
    }
}
</script>
<style scoped>
.control-width{
    width: 600px;
}
.input-title{
    font-size: 15px;
}
@media (min-width: 768px) and (max-width: 991px){
   
}
@media (max-width: 767px){
    .control-width{
        width:500px;
    }
}
@media (max-width: 550px){
    .control-width{
        width:98%;
    }
}
</style>